import { useEffect, useRef, useState } from 'react';
export const useTooltipState = ({ initialOpen = false } = {}) => {
    const [expanded, setExpanded] = useState(initialOpen);
    const [hovered, setHovered] = useState(false);
    const wrapperRef = useRef(null);
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const handleClose = (e) => {
            if (expanded &&
                (e.target === window ||
                    (wrapperRef.current &&
                        wrapperRef.current.contains &&
                        !wrapperRef.current.contains(e.target)))) {
                setExpanded(false);
                setHovered(false);
                removeEventListener('click', handleClose);
                removeEventListener('focusin', handleClose);
                removeEventListener('blur', handleClose);
            }
        };
        if (wrapperRef.current && expanded) {
            addEventListener('click', handleClose);
            addEventListener('focusin', handleClose);
            addEventListener('blur', handleClose);
        }
        return () => {
            removeEventListener('click', handleClose);
            removeEventListener('focusin', handleClose);
            removeEventListener('blur', handleClose);
        };
    }, [expanded]);
    const handleKeyDown = (e) => {
        if (e.key === 'Esc' || e.key === 'Escape') {
            setExpanded(false);
        }
    };
    const toggleExpanded = () => {
        setExpanded(!expanded);
        setHovered(false);
    };
    return {
        expanded,
        handlers: {
            onKeyDown: handleKeyDown,
            onClick: () => setExpanded(true),
            onFocus: () => setExpanded(true),
            onMouseEnter: () => setHovered(true),
            onMouseLeave: () => setHovered(false),
        },
        hovered,
        open: expanded || hovered,
        setExpanded,
        setHovered,
        toggleExpanded,
        wrapperRef,
    };
};
